import { Repository, sortBy, uniqBy } from '@frontend-site/shared/utils';
import { UsersState } from './users-state';
import { combineLatest, map, Observable } from 'rxjs';
import { User } from '@frontend-site/shared/data';
import { createStore, select, withProps } from '@ngneat/elf';
import { Injectable } from '@angular/core';

function createInitialState(): UsersState {
    return {
        users: [],
        disconnectedUsers: [],
        inactiveUsers: []
    };
}
@Injectable({ providedIn: 'root' })
export class UsersStore extends Repository<UsersState> {
    activeUsers$: Observable<User[]> = this.store.pipe(select((state) => state.users));
    inactiveUsers$: Observable<User[]> = this.store.pipe(select((state) => state.inactiveUsers));
    disconnectedUsers$: Observable<User[]> = this.store.pipe(select((state) => state.disconnectedUsers));

    allUsers$ = combineLatest([this.activeUsers$, this.disconnectedUsers$, this.inactiveUsers$]).pipe(
        map((arr: [User[], User[], User[]]) => arr.flat()),
        map((arr: User[]) => arr.concat().sort(sortBy('name'))),
        map((arr) => uniqBy(arr, 'id'))
    );

    get users(): User[] {
        return this.getValue().users ?? [];
    }
    get inactiveUsers(): User[] {
        return this.getValue().inactiveUsers ?? [];
    }
    get disconnectedUsers(): User[] {
        return this.getValue().disconnectedUsers ?? [];
    }

    get allUsers(): User[] {
        return [...this.users, ...this.disconnectedUsers, ...this.inactiveUsers];
    }

    constructor() {
        super(createStore({ name: 'UsersStore' }, withProps<UsersState>(createInitialState())));
    }

    setUsers(activeUsers: User[], inactiveUsers: User[], disconnectedUsers: User[]): void {
        this.update({ users: activeUsers, inactiveUsers, disconnectedUsers });
    }
}
